export default __webpack_public_path__ + "static/media/52.92db9427.jpeg";